// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Plaid = require("../../../shared/src/bindings/Plaid.bs.js");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");

function buttonStyleType(disabled) {
  if (disabled) {
    return /* Disabled */0;
  } else {
    return /* Enabled */{
            _0: /* Blurred */0,
            _1: /* NoInteraction */0
          };
  }
}

function makeProps(disabledOpt, onSuccess, publicKey) {
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var arg = Curry._1(BrowserStyle.merge, {
        hd: BrowserComponents_Button.Styles.button(/* Primary */0, buttonStyleType(disabled), /* LightBackground */0),
        tl: {
          hd: BrowserComponents_Button.Styles.container(/* Medium */1),
          tl: {
            hd: BrowserComponents_Button.Styles.title(/* Primary */0, /* Medium */1, buttonStyleType(disabled), /* LightBackground */0),
            tl: /* [] */0
          }
        }
      });
  var arg$1 = function (publicToken, metadata) {
    return IOUtils.unsafeRunHandledAsync(Curry._2(onSuccess, publicToken, metadata.account_id));
  };
  var arg$2 = ["auth"];
  var arg$3 = Curry._1(Plaid.Key.toString, publicKey);
  var arg$4 = {};
  return function (param, param$1) {
    return function (param$2) {
      return function (param$3, param$4) {
        var param$5 = true;
        var tmp = {
          clientName: param$1,
          env: param$2,
          onSuccess: arg$1,
          product: arg$2,
          publicKey: arg$3,
          selectAccount: param$5,
          style: arg$4
        };
        if (param !== undefined) {
          tmp.children = Caml_option.valFromOption(param);
        }
        if (arg !== undefined) {
          tmp.className = Caml_option.valFromOption(arg);
        }
        if (param$3 !== undefined) {
          tmp.key = Caml_option.valFromOption(param$3);
        }
        return tmp;
      };
    };
  };
}

exports.buttonStyleType = buttonStyleType;
exports.makeProps = makeProps;
/* Plaid Not a pure module */
